<template>
  <AntConfigProvider :locale="ruRU" :theme="{token: customTheme}">
    <NotifierIframeBlock />
    <RouterView v-if="keycloakAPI.getIsLoggedIn.value" />
    <LoadingPage v-else />
  </AntConfigProvider>
</template>

<script lang="ts">
export default {};
</script>

<script setup lang="ts">
import 'dayjs/locale/ru';

import ruRU from 'ant-design-vue/es/locale/ru_RU';
import dayjs from 'dayjs';

import {subordination} from '@/config/subordination';
import {customTheme} from '@/config/theme';

import {keycloakAPI} from '@/assets/keycloak';

import AntConfigProvider from '@/assets/ant/config_provider/AntConfigProvider.vue';

import NotifierIframeBlock from '@/components/blocks/NotifierIframeBlock.vue';
import LoadingPage from '@/pages/LoadingPage.vue';

dayjs.locale(ruRU.locale);
subordination.init();
</script>

<style lang="scss">
@import 'assets/styles/defaults';

.loading {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
